import { API } from "@infra/api";
import type { Company } from "@domain/CRM/company";
import type { User } from "@domain/Auth";
import { makeCompaniesUseCases } from "@app/company";

export const companiesUseCases = makeCompaniesUseCases({
	getCompaniesByUser: (user: User) => API.Data.Companies.get.byUser(user) as Promise<Company[]>,
});
